import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import crownUrl from 'shared/assets/images/crown.svg';
import { FormattedMessage } from 'react-intl';
import Carousel from 'desktop/components/Carousel/Carousel';
import AdvertCarCard from 'desktop/components/AdvertCarCard/AdvertCarCard';

import s from './TopCars.css';

const IMAGE_WIDTH = 257;
class TopCars extends React.Component {
  static propTypes = {
    withoutTitle: PropTypes.bool,
    cars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    currency: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    withoutTitle: false,
  };

  render() {
    const { withoutTitle, cars, currency } = this.props;
    // const { withoutTitle } = this.props;
    // const imageStyles = { height: '200px' };
    const imageStyles = {};

    return (
      <div className={s.root}>
        <Carousel
          step={3}
          itemsInRow={3}
          loop
          classNames={{
            header: s.header,
            body: s.carouselBody,
          }}
          header={
            !withoutTitle &&
            <div className={s.best}>
              <img src={crownUrl} width="26" height="32" alt="" />&nbsp;{' '}
              <FormattedMessage id="Лучшие предложения" />
            </div>
          }
          items={cars.map((car, idx) =>
            <AdvertCarCard
              key={car.id}
              advert={car}
              index={idx}
              currency={currency}
              imageStyle={imageStyles}
              advertClassName={s.advertItem}
              advertThumbClassName={s.advertThumbItem}
              width={IMAGE_WIDTH}
            />,
          )}
        />
      </div>
    );
  }
}

export default withStyles(s)(TopCars);



// WEBPACK FOOTER //
// ./src/desktop/components/TopCars/TopCars.js